<template>
  <b-overlay :show="show">
    <exercice-view :exercice="exercice" @load="getData"/>
    <hr>
    <b-button-toolbar class="ml-1 mt-1 justify-content-between">
      <b-btn variant="outline-primary" @click="retour" class="mr-1">RETOUR</b-btn>
      <b-btn v-if="!!this.textID" variant="primary" @click="seeText">VOIR MON EXERCICE</b-btn>
      <b-btn v-else variant="primary" @click="createText">FAIRE L'EXERCICE</b-btn>
    </b-button-toolbar>
  </b-overlay>
</template>

<script>
import {Textes} from "@/js/caller";
import {History} from "@/js/history";
import ExerciceView from "../../components/exerciceView";

function getExercice() {
  const params = new URL(window.location.href).searchParams;
  const exercice = params.get("id_exercice") || params.get("id") || null;
  return {exercice};
}

export default {
  name      : "Exercice",
  components: {ExerciceView},
  data() {
    return {
      show    : true,
      exercice: null,
      data    : {},
      textID  : null
    }
  },
  methods: {
    formatContenu(contenu) {
      return contenu.replaceAll(/<br( |)\/>/g, '')
    },
    createText() {
      const {id, titre, contenu, document} = this.data
      const {id: textID} = Textes.createLocal({
        exercice      : id,
        title         : titre,
        texte_original: this.formatContenu(contenu),
        document
      });
      History.GoTo('EditorTexts', {item: textID})
    },
    seeText() {
      const id = this.textID;
      History.GoTo('EditorTexts', {item:{id}})
    },
    retour() {
      window.location.href = "/mon_compte.php?exercices=TRUE";
    },
    getData(data) {
      this.data = data;
    }
  },
  async created() {
    let {exercice} = getExercice();
    if (!exercice) exercice = 22
    this.exercice = exercice;
    this.textID = await Textes
        .GetList({Equal: [{field: "exercice", value: this.exercice}]})
        .then(res => (res.find(t => t.exercice === this.exercice) || {}).id);
    this.show = false
  }
}
</script>

<style scoped>

</style>